module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/898kBm/tc-custom/9781488090349.jpg?1721429486764",
      "alt": "This image is the cover for the book Bachelor's Baby, Liberty Creek"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bachelor's Baby, Liberty Creek\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Forging a Family")]), _c('br'), _c('br'), _vm._v("Single mom-to-be Lindsay Holland is hoping for a fresh start in her sleepy New England hometown. First on her agenda is finding a way to support herself and her precious baby. But the only job opening is as an office manager for her high-school sweetheart—the man she once ran from. She knows Brian Calhoun needs help resurrecting his family’s blacksmith shop, but can she get him to take a chance on her? Organizing a Valentine’s Day fund-raiser together makes Lindsay realize just how much she wants a second chance with the handsome craftsman. As sparks fly, can they transform their rekindled friendship into a new, loving family?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mia Ross\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Mia Ross loves great stories. She enjoys reading about fascinating people, long-ago times, and exotic places. But only for a little while, because her reality is pretty sweet. A lifelong resident of Upstate New York, she's married and the proud mom of 2 amazing kids whose schedules keep her hopping. Busy as she is, she can't imagine trading her life for anyone else's--and she has a pretty good imagination. You can visit her online at www.miaross.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0